import { useContext, useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Select from 'react-select'
import { Form } from 'react-bootstrap'
import * as FormWizardStyles from '../../../../components/organisms/FormWizard/styles'
import { FormWizardHandlers } from '../../../../components/organisms/FormWizard'
import {
  SelectField,
  SelectFieldOption
} from '../../../../components/atoms/SelectField'
import { CreateContractsContext } from '../index'
import { Button, Col, Row } from 'react-bootstrap'
import { useToast } from '../../../../hooks/useToast'
import { useContextPage } from '../contextPage'
import step2_schema from './step2.schema'
import { Contract } from '../../../../domain/usecases/Contracts'
import { AppContext } from '../../../../app'
import { getUauSellers, UauSeller } from '../../../../services/contracts'

export type ICreateContractsFormStep2 = Pick<
  Contract.CreateParams,
  'spe_id' | 'uau_vendedor_code'
>

type SellerOption = {
  label: string
  value: string
}

const Step2 = ({ nextHandler, backHandler }: FormWizardHandlers) => {
  const { showToast } = useToast()
  const { data, setData } = useContext(CreateContractsContext)
  const { user } = useContext(AppContext)
  const { getSpes } = useContextPage()
  const [spes, setSpes] = useState<SelectFieldOption[]>([])
  const [sellers, setSellers] = useState<SellerOption[]>([])
  const [loadingSellers, setLoadingSellers] = useState(true)

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm<ICreateContractsFormStep2>({
    resolver: yupResolver(step2_schema),
    defaultValues: {
      ...data
    }
  })

  useEffect(() => {
    getSpeslist()
  }, [])

  useEffect(() => {
    console.log('Step2 useEffect - user?.token:', !!user?.token, 'user:', user)
    if (user?.token) {
      console.log('Step2 - calling getSellersList')
      getSellersList()
    } else {
      console.log('Step2 - no token, setting loadingSellers to false')
      setLoadingSellers(false)
    }
  }, [user?.token])

  const onClickNext = (formData: ICreateContractsFormStep2) => {
    setData?.({ ...data, ...formData })
    nextHandler()
  }

  const getSpeslist = async () => {
    try {
      const spes = await getSpes.getAll()
      setSpes(
        spes.map((item) => ({ label: item.business_name, value: item.id }))
      )
    } catch (error) {
      showToast('Não foi possível carregar as SPEs.', 'error')
    }
  }

  const getSellersList = async () => {
    console.log('getSellersList START')
    setLoadingSellers(true)
    try {
      console.log(
        'getSellersList - calling API with token:',
        user!.token?.substring(0, 20) + '...'
      )
      console.log(
        'getSellersList - context:',
        user!.selectedContextEncoded?.substring(0, 50) + '...'
      )
      const sellersData = await getUauSellers(
        user!.token,
        user!.selectedContextEncoded
      )
      console.log('getSellersList - API response:', sellersData)
      if (Array.isArray(sellersData)) {
        console.log('getSellersList - mapping', sellersData.length, 'sellers')
        setSellers(
          sellersData.map((seller: UauSeller) => ({
            label: `${seller.nomeVendedor || seller.nome || 'Sem nome'}${
              seller.cpf ? ` (${seller.cpf})` : ''
            }`,
            value: String(seller.codigoVendedor ?? seller.codigo)
          }))
        )
      } else {
        console.log('getSellersList - Unexpected response format:', sellersData)
        setSellers([])
      }
    } catch (error) {
      console.log('getSellersList ERROR:', error)
      setSellers([])
    } finally {
      console.log('getSellersList FINALLY - setting loadingSellers to false')
      setLoadingSellers(false)
    }
  }

  return (
    <FormWizardStyles.TabContent>
      <Row>
        <Col md={6}>
          <Controller
            control={control}
            name="spe_id"
            render={({ field: { onChange, value } }) => {
              return (
                <SelectField
                  disabled={data?.spe_id ? true : false}
                  data-testid="select-spes"
                  emptyOptionText={'Selecione'}
                  errorMessage={errors.spe_id?.message}
                  defaultValue={data?.spe_id || ''}
                  value={value}
                  onChange={onChange}
                  label="Selecione a SPE do Promitente"
                  options={spes}
                />
              )
            }}
          />
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Vendedor UAU (Opcional)</Form.Label>
            <Controller
              control={control}
              name="uau_vendedor_code"
              render={({ field: { onChange, value } }) => (
                <Select
                  isClearable
                  isSearchable
                  isLoading={loadingSellers}
                  placeholder="Selecione um vendedor..."
                  noOptionsMessage={() => 'Nenhum vendedor encontrado'}
                  loadingMessage={() => 'Carregando vendedores...'}
                  options={sellers}
                  value={sellers.find((s) => s.value === value) || null}
                  onChange={(option) => onChange(option?.value || null)}
                />
              )}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormWizardStyles.ButtonsWrapperSpaced>
            <Button variant="link" onClick={backHandler}>
              Voltar
            </Button>
            <Button variant="primary" onClick={handleSubmit(onClickNext)}>
              Próximo
            </Button>
          </FormWizardStyles.ButtonsWrapperSpaced>
        </Col>
      </Row>
    </FormWizardStyles.TabContent>
  )
}
export default Step2
